import type { Analytics } from "@models/analytics.model";

export default function FileUploadSummary({ analytics }: { analytics: Analytics }) {
    const lastUpload = analytics.charts?.["ingest-metrics"]?.last_upload_date;

    return (
        <div className="dash-card">
            <div className="dash-card__head">
                <span className="dash-card__title">File Upload Summary</span>
            </div>
            <div className="dash-card__body">
                <div style={{
                    border: "1px solid #e5e7eb",
                    borderRadius: 8,
                    padding: 16,
                    background: "#f9fafb",
                }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: "#111827" }}>
                        Date of last upload
                    </div>
                    <div style={{
                        fontSize: 18,
                        fontWeight: 700,
                        color: lastUpload ? "#845adf" : "#9ca3af",
                        marginTop: 4,
                    }}>
                        {lastUpload
                            ? new Date(lastUpload).toLocaleDateString("en-US", {
                                  year: "numeric",
                                  month: "short",
                                  day: "numeric",
                              })
                            : "—"}
                    </div>
                </div>
            </div>
        </div>
    );
}
